import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { LetterShowClick, ReminderToMedicalLetterValidate } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../service/ProductService';
import { DOWNLOADREMINDERLETTER, REMINDERLETTER, STOREREMINDER } from '../../../config/ApiConstant';
import { ReminderToMediaclListColumns } from '../../../appconfig/DatatableSetting';
import { commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputTextarea } from 'primereact/inputtextarea';
import { LettersTab } from '../LettersTab';
import { ReminderTab } from './ReminderLettersTab';
import Loader from '../../../components/Loadeer/Loader';

export const ReminderToMedical = () => {
    document.title = 'Medical Reminder Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [medicalData, setMedicalData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [medicalList, setMedicalList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);

    // useEffect
    useEffect(() => {
        reminderToMedicalLetter();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        reminderToMedicalLetter();
        setMedicalData({});
        setErrors({});
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setMedicalData({ ...medicalData, [name]: val });
    };

    // getUniversitLetterList
    const reminderToMedicalLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                const response = await getAllDetailsDirect(REMINDERLETTER + '?ReminderBy=Medical' + '&FileNo=' + regNo);
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setMedicalData({
                        Name: FromNm
                    });
                    setMedicalList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setMedicalData({ ...medicalData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(REMINDERLETTER + '?ReminderBy=Medical');

                if (response) {
                    const { List } = response;
                    setMedicalList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    // onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                // setPageLoad(false);

                reminderToMedicalLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    // Add inward data
    const addmedicalData = async () => {
        try {
            const { errors, isError } = ReminderToMedicalLetterValidate(medicalData, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let requestData = { ...medicalData };
                requestData['FileNo'] = Number(regNo);
                requestData['ReminderBy'] = 'Medical';
                requestData['ReminderId'] = 0;

                const response = await postAllData(STOREREMINDER, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setMedicalData({});
                    clearAll();
                    reminderToMedicalLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadreminderToMedicalLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadreminderToMedicalLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADREMINDERLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `Reminder-Medical-Letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Reminder Letters" />
            <ReminderTab initialTabLabel="Reminder To Medical" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(medicalData?.Name) ? medicalData?.Name : ''} name="Name" disabled={true} />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="ReminderName">
                                    Medical Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(medicalData?.ReminderName) ? medicalData?.ReminderName : ''} name="ReminderName" onChange={(e) => onInputChange(e, 'ReminderName')} className={errors['ReminderName'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['ReminderName']}</small>
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="Reference">
                                    Reference <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(medicalData?.Reference) ? medicalData?.Reference : ''} name="Reference" onChange={(e) => onInputChange(e, 'Reference')} className={errors['Reference'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['Reference']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ToAddress">
                                    Address <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputTextarea value={!window.cn(medicalData?.ToAddress) ? medicalData?.ToAddress : ''} name="ToAddress" onChange={(e) => onInputChange(e, 'ToAddress')} rows={4} className={errors['ToAddress'] && 'p-invalid'} />
                                <small className="flex align-items-center">
                                    <span className="p-invalid-txt mr-2">Note :</span> Use ( , ) for the Address separation
                                </small>

                                <small className="p-invalid-txt">{errors['ToAddress']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addmedicalData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={medicalList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={medicalList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {ReminderToMediaclListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'UniBordCol') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'ToAddress') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else if (col.field === 'FileNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '8rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ReminderToMediaclListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}
        </>
    );
};
